import React from "react";
import LegalLayout from "../components/LegalLayout";

const updatedAt = "10 באוגוסט 2025";

export default function TermsOfUse() {
  return (
    <LegalLayout title="תנאי שימוש – Sitechs" subtitle={`עדכון אחרון: ${updatedAt}`}>
      <section className="space-y-6">
        <h2 className="text-2xl font-bold">הסכמה לתנאים</h2>
        <p>הכניסה לאתר והשימוש בו מהווים הסכמה לתנאים אלה. אם אינכם מסכימים – הימנעו משימוש באתר.</p>

        <h2 className="text-2xl font-bold mt-8">השירות והתוכן באתר</h2>
        <p>האתר מציג מידע על שירותי פיתוח עמודי נחיתה ואתרים, ומאפשר יצירת קשר לקבלת ייעוץ/הצעת מחיר. המידע באתר נועד להמחשה כללית בלבד, ואינו מהווה התחייבות לתוצאה, ייעוץ מקצועי או הצעה מחייבת. אין באתר אפשרות לביצוע תשלומים אונליין.</p>

        <h2 className="text-2xl font-bold mt-8">פניות והתקשרויות מסחריות</h2>
        <p>מסירת פרטים בטופס יוצרת פנייה ראשונית בלבד. כל התקשרות מסחרית (מחיר, לו"ז, אחריות, תוצרים) תוסדר בהסכם/הצעת מחיר פרטנית שתימסר לכם ותעמוד מעל האמור באתר במקרה של סתירה.</p>

        <h2 className="text-2xl font-bold mt-8">יצירת קשר ב‑WhatsApp</h2>
        <p>הקלקה על כפתור/קישור WhatsApp מפנה לשיחה פרטית באפליקציה. עצם פתיחת השיחה מהווה הסכמה לקבלת מענה והודעות מאיתנו באותו ערוץ, בכפוף לדין וליכולת הסרה בכל עת.</p>

        <h2 className="text-2xl font-bold mt-8">שימוש מותר ואסור</h2>
        <p>אין להשתמש באתר בניגוד לדין, לצורך פגיעה בפרטיות, אבטחה או זכויות קניין רוחני; אין לבצע סריקה אוטומטית/כרייה/רכיבים זדוניים; ואין לשבש את פעולת האתר. אנו רשאים לחסום גישה לפי שיקול דעתנו.</p>

        <h2 className="text-2xl font-bold mt-8">קניין רוחני</h2>
        <p>כל הזכויות בתכני האתר, לרבות טקסטים, עיצובים, קוד, תמונות וסימני מסחר – שמורות לסייטקס או לצדדים שלישיים שנתנו רישיון. אין להעתיק/להפיץ/ליצור יצירות נגזרות ללא אישור מראש ובכתב.</p>

        <h2 className="text-2xl font-bold mt-8">קישורים לאתרים חיצוניים</h2>
        <p>האתר עשוי לכלול קישורים או הטמעות של צדדים שלישיים. איננו אחראים לתוכנם, מדיניותם או זמינותם.</p>

        <h2 className="text-2xl font-bold mt-8">אחריות והגבלת אחריות</h2>
        <p>השימוש באתר הוא "כפי שהוא" (AS‑IS). במידה המרבית המותרת בדין, לא נהיה אחראים לכל נזק ישיר/עקיף/תוצאתי הנובע מן השימוש באתר או הסתמכות על מידע בו.</p>

        <h2 className="text-2xl font-bold mt-8">שיפוי</h2>
        <p>המשתמש מתחייב לשפות את סייטקס ועובדיה בגין כל נזק/הוצאה שייגרמו עקב הפרת תנאים אלה או שימוש שאינו חוקי.</p>

        <h2 className="text-2xl font-bold mt-8">שינוי, השהיה וסיום</h2>
        <p>אנו רשאים לעדכן את האתר/התנאים, להשעותו או לסיימו בכל עת.</p>

        <h2 className="text-2xl font-bold mt-8">דין וסמכות שיפוט</h2>
        <p>על תנאים אלה יחולו דיני מדינת ישראל בלבד. סמכות השיפוט הבלעדית נתונה לבתי המשפט המוסמכים במחוז ירושלים.</p>

        <h2 className="text-2xl font-bold mt-8">יצירת קשר</h2>
        <p>לשאלות בנוגע לתנאים/פרטיות: 058-45678-77 | service@sitechs.co.il.</p>

        <hr className="my-8 border-gray-200" />
        <p className="text-gray-500 text-sm"></p>
      </section>
    </LegalLayout>
  );
}